// Doughnut Graph
$(function() {
    let Stat_Doughnut_Graph = {
        init: function(){
            let self = this;

            let chartElements = document.querySelectorAll(".stat-doughnut-graph");

            if(chartElements) {
                for (let i = 0; i < chartElements.length; i++) {
                    self.loadGraph(chartElements[i]);
                }
            }
        },

        loadGraph: function(chartElement) {
            let self = this;

            let context = chartElement.getContext('2d');
            let dataFromAttribute = [100,0];

            if(chartElement.getAttribute('data-values')) {
                dataFromAttribute = chartElement.getAttribute('data-values').split(',');
            }

            let colorFromAttribute = "#cccccc";
            if(chartElement.getAttribute('data-color')) {
                colorFromAttribute = chartElement.getAttribute('data-color');
            }

            let config = {
                type: 'RoundedDoughnut',
                data: {
                    labels: [
                        "Value"
                    ],
                    datasets: [{
                        data: dataFromAttribute,
                        backgroundColor: [
                            colorFromAttribute,
                            "rgba(0,0,0,0)"
                        ],
                        hoverBackgroundColor: [
                            colorFromAttribute,
                            "rgba(0,0,0,0)"
                        ],
                        borderWidth: [
                            0, 0
                        ]
                    }]
                },
                options: {
                    cutoutPercentage: 82,
                    animation: {
                        animationRotate: true,
                        duration: 1000
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        enabled: false
                    },
                }
            };

            let statDoughnutChart = new Chart(context, config);


            return this;
        }
    }.init();
});